/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { createEntity, getEntity, reset, updateEntity } from './doctor-hospital-association.reducer';

export const DoctorHospitalAssociationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const doctors = useAppSelector(state => state.doctor.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const doctorHospitalAssociationEntity = useAppSelector(state => state.doctorHospitalAssociation.entity);
  const loading = useAppSelector(state => state.doctorHospitalAssociation.loading);
  const updating = useAppSelector(state => state.doctorHospitalAssociation.updating);
  const updateSuccess = useAppSelector(state => state.doctorHospitalAssociation.updateSuccess);

  const handleClose = () => {
    navigate(`/doctor-hospital-association${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDoctors({}));
    dispatch(getHospitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.joiningDt !== undefined && typeof values.joiningDt !== 'number') {
      values.joiningDt = Number(values.joiningDt);
    }
    if (values.leavingDate !== undefined && typeof values.leavingDate !== 'number') {
      values.leavingDate = Number(values.leavingDate);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.createdDtm !== undefined && typeof values.createdDtm !== 'number') {
      values.createdDtm = Number(values.createdDtm);
    }
    if (values.lastModifiedDtm !== undefined && typeof values.lastModifiedDtm !== 'number') {
      values.lastModifiedDtm = Number(values.lastModifiedDtm);
    }
    if (values.leavingDt !== undefined && typeof values.leavingDt !== 'number') {
      values.leavingDt = Number(values.leavingDt);
    }

    const entity = {
      ...doctorHospitalAssociationEntity,
      ...values,
      doctor: doctors.find(it => it.id.toString() === values.doctor?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...doctorHospitalAssociationEntity,
          doctor: doctorHospitalAssociationEntity?.doctor?.id,
          hospital: doctorHospitalAssociationEntity?.hospital?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.doctorHospitalAssociation.home.createOrEditLabel" data-cy="DoctorHospitalAssociationCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.home.createOrEditLabel">
              Create or edit a DoctorHospitalAssociation
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="doctor-hospital-association-id"
                  label={translate('tinyMedicRestApp.doctorHospitalAssociation.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorHospitalAssociation.joiningDt')}
                id="doctor-hospital-association-joiningDt"
                name="joiningDt"
                data-cy="joiningDt"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorHospitalAssociation.leavingDate')}
                id="doctor-hospital-association-leavingDate"
                name="leavingDate"
                data-cy="leavingDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorHospitalAssociation.timestampentry')}
                id="doctor-hospital-association-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorHospitalAssociation.microSec')}
                id="doctor-hospital-association-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorHospitalAssociation.lastupdated')}
                id="doctor-hospital-association-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorHospitalAssociation.active')}
                id="doctor-hospital-association-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorHospitalAssociation.cursor')}
                id="doctor-hospital-association-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorHospitalAssociation.dutyStartTime')}
                id="doctor-hospital-association-dutyStartTime"
                name="dutyStartTime"
                data-cy="dutyStartTime"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorHospitalAssociation.dutyEndTime')}
                id="doctor-hospital-association-dutyEndTime"
                name="dutyEndTime"
                data-cy="dutyEndTime"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorHospitalAssociation.tmPermanent')}
                id="doctor-hospital-association-tmPermanent"
                name="tmPermanent"
                data-cy="tmPermanent"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorHospitalAssociation.createdDtm')}
                id="doctor-hospital-association-createdDtm"
                name="createdDtm"
                data-cy="createdDtm"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorHospitalAssociation.lastModifiedDtm')}
                id="doctor-hospital-association-lastModifiedDtm"
                name="lastModifiedDtm"
                data-cy="lastModifiedDtm"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorHospitalAssociation.createdBy')}
                id="doctor-hospital-association-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorHospitalAssociation.modifiedBy')}
                id="doctor-hospital-association-modifiedBy"
                name="modifiedBy"
                data-cy="modifiedBy"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorHospitalAssociation.leavingDt')}
                id="doctor-hospital-association-leavingDt"
                name="leavingDt"
                data-cy="leavingDt"
                type="text"
              />
              <ValidatedField
                id="doctor-hospital-association-doctor"
                name="doctor"
                data-cy="doctor"
                label={translate('tinyMedicRestApp.doctorHospitalAssociation.doctor')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="doctor-hospital-association-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.doctorHospitalAssociation.hospital')}
                type="select"
                required
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/doctor-hospital-association" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DoctorHospitalAssociationUpdate;
